import React from "react";
import { Link } from "react-router-dom";

/**
 * ConnexisMark — the marketing header lockup, reusable across private surfaces.
 * Two colour modes: `light` (dark navy lockup on white) and `dark` (white lockup on navy).
 */
export function ConnexisMark({ mode = "light", asLink = true }) {
  const darkBg   = mode === "dark";
  const boxBg    = darkBg ? "bg-white"   : "bg-slate-900";
  const strokeCl = darkBg ? "text-slate-900" : "text-white";
  const wordCl   = darkBg ? "text-white"    : "text-slate-900";
  const inner = (
    <span className="inline-flex items-center gap-2.5">
      <span className={`inline-flex h-7 w-7 items-center justify-center rounded-md ${boxBg}`}>
        <svg viewBox="0 0 24 24" className={`h-4 w-4 ${strokeCl}`} fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M4 7h7M4 12h12M4 17h7" strokeLinecap="round" />
          <circle cx="18" cy="7" r="2.2" fill="#0055FF" stroke="none" />
          <circle cx="18" cy="17" r="2.2" fill="#0055FF" stroke="none" />
        </svg>
      </span>
      <span className={`text-[15px] font-semibold tracking-tight ${wordCl}`}>
        Connexis<span className="text-[#0055FF]">.</span>
      </span>
    </span>
  );
  if (!asLink) return inner;
  return <Link to="/" data-testid="connexis-mark">{inner}</Link>;
}
